<template>
  <div class="sn-f-col-b-c recharge">
    <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
      <div class="sn-f-s-c region">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>就诊人：</div>
        </div>
        <div v-if="!$sn.validate.array(patientList)" @click="handlePatientInfo();">
          暂未获取到就诊人，<span class="sn-pointer sn-fc-main">点击刷新</span>
        </div>
        <div v-else-if="patientList.length === 0" @click="navigateUrl('addition-patient');">
          暂无就诊人，<span class="sn-pointer sn-fc-main">点击添加</span>
        </div>
        <template v-else>
          <el-select :value="selectedPatient.patientId" @change="sendBackPatient">
            <el-option :key="patient.patientId" :label="patient.patientName" :value="patient.patientId" v-for="patient in patientList"></el-option>
          </el-select>
        </template>
      </div>
      <div class="sn-f-s-c region" v-if="selectedPatient.patientId">
        <div class="sn-f-s-c patient-title">
          <div class="required">*</div>
          <div>住院号：</div>
        </div>
        <div v-if="!inCardSerial" @click="navigateUrl('addition-card');">
          {{ inCardSerialFormat }}，<span class="sn-pointer sn-fc-main">点击绑定</span>
        </div>
        <div v-else>
          <el-input readonly="readonly" v-model="inCardSerialFormat"></el-input>
        </div>
      </div>
      <div class="sn-f-s-c region" v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_JNYZ && inCardPrefixSum">
        <div class="sn-f-s-c patient-title">
          <div>预交押金总额：</div>
        </div>
        <div class="sn-fc-red1 sn-fw-bold">{{ inCardPrefixSum }}</div>
      </div>
      <div class="sn-f-s-c region" v-if="$sn.getConfig('isExhibitionInRechargeCardBalance') && selectedPatient.patientId && inCardBalance">
        <div class="sn-f-s-c patient-title">
          <div>当前可用余额：</div>
        </div>
        <div class="sn-fc-red1 sn-fw-bold">{{ inCardBalance === '--.--' ? inCardBalance : $sn.format.priceFormat(inCardBalance, 2) }}</div>
      </div>
    </div>
    <div class="sn-f-1 recharge-region">
      <opt :option="$sn.getConfig('inRechargeOption')" @sendBack="sendBackOption"></opt>
      <div class="sn-f-b-s operate" v-if="rechargePattern.length > 0">
        <div class="sn-f-s-0 operate-title">支付方式：</div>
        <div class="sn-f-1 sn-f-s-c operate-region">
          <div class="sn-f-c-c sn-pointer pattern" :style="{'--background': item.background}" :key="item.reg" v-for="item in rechargePattern" @click="goRecharge(item.reg);">
            <div class="iconfont" :class="item.icon"></div>
            <div>{{ item.title }}</div>
          </div>
        </div>
      </div>
      <div class="sn-prompt" v-if="promptInfo.length > 0">
        <div class="sn-prompt-title">温馨提示</div>
        <div class="sn-f-s-s sn-prompt-caption" :class="item.type === '2' ? 'sn-fc-red1 ' + item.style : item.style" :key="i" v-for="(item, i) in promptInfo">
          <div class="sn-prompt-star">★</div>
          <div v-html="item.info"></div>
        </div>
      </div>
    </div>
    <pay-result v-if="exhibitionPayResult" :params="payResultParams" @sendBack="sendBackPayResult">
      <template v-slot:result>
        <div class="sn-f-col-s-c result-slot">
          <div class="sn-f-s-c result-line">
            <div><span style="letter-spacing: 0.5em;">住院</span>人：</div>
            <div class="sn-f-1 sn-omit">{{ selectedPatient.patientName }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div><span style="letter-spacing: 0.5em;">住院</span>号：</div>
            <div class="sn-f-1 sn-omit">{{ inCardSerialFormat }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>{{ payResultParams.label }}单号：</div>
            <div class="sn-f-1 sn-omit">{{ Object.values(payResultParams.pay)[0].serial }}</div>
          </div>
          <div class="sn-f-s-c result-line">
            <div>{{ payResultParams.label }}金额：</div>
            <div class="sn-f-1 sn-omit">{{ payResultParams.cost }}</div>
          </div>
        </div>
      </template>
    </pay-result>
    <create-patient v-if="exhibitionCreatePatient" @sendBack="sendBackCreatePatient"></create-patient>
    <bind-card v-if="exhibitionBindCard" :type="perpetual.IN_CARD_CLINIC_TYPE" :patientId="selectedPatient.patientId || ''" @sendBack="sendBackBindCard"></bind-card>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';

export default {
  components: {
    'opt': () => import('@/pages/recharge/opt'),
    'pay-result': () => import('@/components/pay-result'),
    'create-patient': () => import('@/components/create-patient'),
    'bind-card': () => import('@/components/bind-card')
  },
  mixins: [HomepageMixin],
  data() {
    return {
      patientList: [],
      selectedPatient: {},
      inCardSerial: '',
      inCardSerialFormat: '',
      inCardBalance: '--.--',
      inCardPrefixSum: '',
      rechargeCost: '',
      rechargePattern: [],
      promptInfo: [],
      //
      isThroughRechargeTimeVerification: true,
      //
      isRestrictRechargeCost: false,
      //
      isShowVerifyInCardBalancePrompt: false,
      //
      isSystemFailed: false,
      //
      isShowInCardIrregularPrompt: false,
      //
      maxInRecharge: self.$sn.getConfig('maxInRecharge'),
      inRechargeMerchantSerial: self.$sn.getConfig('inRechargeMerchantSerial'),
      //
      exhibitionCreatePatient: false,
      //
      exhibitionBindCard: false
    };
  },
  watch: {
    selectedPatient: async function(patient) {
      this.inCardSerial = '';
      this.inCardSerialFormat = '';
      this.inCardBalance = '--.--';
      this.inCardPrefixSum = '';
      if (patient.patientId) {
        const handle = await Tools.handlePatientInfo(patient, this.perpetual.IN_CARD_CLINIC_TYPE);
        if (handle.code >= 0) {
          if (handle.code === 4) {
            let caption = this.$sn.format.caption(Messages.SEARCH017, [this.$sn.getConfig('cardInName')]);
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
              caption = Messages.RECHARGE024;
            }
            this.$sn.assembly.modal({
              title: '温馨提示',
              caption: caption,
              success: (modal) => {
                if (modal.confirm) {
                  if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SDSL) {
                    this.$sn.assembly.loading(true);
                    this.$sn.utils.ordinaryRequest({
                      url: Swagger.unboundCardInfo,
                      method: 'POST',
                      header: true,
                      data: JSON.stringify({
                        platformId: this.$sn.utils.getPlatformType(),
                        platformUserId: this.$sn.utils.getOpenId(),
                        patId: patient.patientId,
                        cardNo: handle.data.no,
                        hosId: this.$sn.utils.getHospitalId(),
                        cardType: this.perpetual.IN_CARD_CLINIC_TYPE,
                        patientIdCardNo: patient.patientIdCardNo,
                        healthType: '0'
                      })
                    }).then(result => {
                      this.$sn.assembly.loading(false);
                      if (result) {
                        if (result.code === 0) {
                          Tools.modifyPatientInfo(patient.patientId, {
                            inCardId: '',
                            inCardNo: '',
                            patInCardNoEncrypt: ''
                          });
                          patient.inCardId = '';
                          patient.inCardNo = '';
                          patient.patInCardNoEncrypt = '';
                          this.navigateUrl('addition-card');
                        }
                        else {
                          this.$sn.assembly.modal({
                            caption: result.msg,
                            isCancel: false
                          });
                        }
                      }
                      else {
                        this.$sn.assembly.modal({
                          caption: Messages.C001,
                          isCancel: false
                        });
                      }
                    });
                  }
                  else this.navigateUrl('addition-card');
                }
              }
            });
            return false;
          }
          this.inCardSerial = handle.data.no;
          this.inCardSerialFormat = handle.data.caption;
        }
        if (this.inCardSerial) {
          this.treatInCard();
        }
      }
    },
    rechargeCost: {
      handler: function() {
        this.isRestrictRechargeCost = false;
        if (!this.verifyRestrictRechargeCost()) {
          this.isRestrictRechargeCost = true;
        }
      },
      immediate: true
    }
  },
  created: function() {
    this.formatRechargePattern();
    this.verifyCurrentTime(new Date(this.$sn.format.date(new Date(), 'yyyy-MM-dd HH:mm') + ':00'));
    this.handlePatientInfo();
    this.getPromptInfo();
    if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_SZY) {
      this.$sn.assembly.modal({
        title: '温馨提示',
        caption: Messages.RECHARGE017,
        captionCancel: '否',
        captionConfirm: '是',
        success: (modal) => {
          if (modal.cancel) {
            this.navigateUrl('/');
          }
        }
      });
    }
  },
  methods: {
    formatRechargePattern() {
      const compare = {
        '1': {
          'title': '支付宝',
          'icon': 'icon-alipay',
          'background': this.$sn.color.alipay
        },
        '2': {
          'title': '微信',
          'icon': 'icon-weixin2',
          'background': this.$sn.color.wechat
        }
      };
      this.$sn.getConfig('pcPayPattern').forEach(el => {
        if (!this.$sn.validate.empty(compare[el])) {
          this.rechargePattern.push({
            reg: el,
            ...compare[el]
          });
        }
      });
    },
    verifyCurrentTime(time) {
      this.isThroughRechargeTimeVerification = true;
      const startMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeEndTime') + ':00';
      const startMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd', 1, 'day') + ' 00:00:00';
      const endMinDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' 00:00:00';
      const endMaxDate = this.$sn.format.date(new Date(), 'yyyy-MM-dd') + ' ' + this.$sn.getConfig('rechargeStartTime') + ':00';
      const standard = this.$sn.format.date(time, 'yyyy-MM-dd HH:mm:ss');
      if ((standard >= startMinDate && standard <= startMaxDate) || (standard >= endMinDate && standard <= endMaxDate)) {
        this.isThroughRechargeTimeVerification = false;
      }
    },
    async handlePatientInfo() {
      this.$sn.assembly.loading(true);
      await Initial.obtainPatientInfoByCondition();
      this.$sn.assembly.loading(false);
      this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      if (this.patientList && this.patientList.length > 0) {
        this.selectedPatient = this.$sn.utils.getCurrentPatient();
      }
    },
    treatInCard() {
      if (this.$sn.getConfig('isInRechargeVerifyCardPrefixBalance')) this.verifyInCard();
      else this.getInCardBalance();
    },
    verifyInCard() {
      let params = {};
      if (this.$sn.getConfig('isInRechargeVerifyCardSeparateSwagger')) {
        params = {
          url: this.$sn.format.caption(Swagger.verifyInCard, [this.$sn.utils.getHospitalId()]),
          method: 'POST',
          header: true,
          data: JSON.stringify({
            areaCode: this.selectedPatient.hosArea || this.$sn.utils.getHospitalAreaId(),
            cardNo: this.inCardSerial,
            cardType: this.perpetual.IN_CARD_CLINIC_TYPE,
            endDate: '',
            idCardNo: this.selectedPatient.patientIdCardNo,
            idCardType: this.selectedPatient.idCardType,
            patBirthday: '',
            patName: this.selectedPatient.patientName,
            patPhone: '',
            patSex: '',
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId(),
            startDate: ''
          })
        };
      }
      else {
        params = {
          url: Swagger.verifyCard,
          method: 'POST',
          header: true,
          data: JSON.stringify({
            cardNo: this.inCardSerial,
            cardType: this.perpetual.IN_CARD_CLINIC_TYPE,
            hosId: this.$sn.utils.getHospitalId(),
            patId: this.selectedPatient.patientId,
            payType: '1',
            platformId: this.$sn.utils.getPlatformType(),
            platformUserId: this.$sn.utils.getOpenId()
          })
        };
      }
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        this.isSystemFailed = false;
        this.isShowInCardIrregularPrompt = false;
        let verify = false;
        if (this.$sn.getConfig('isInRechargeVerifyCardSeparateSwagger')) {
          verify = !this.$sn.validate.empty(result);
        }
        else {
          verify = !this.$sn.validate.empty(result) && !this.$sn.validate.empty(result.data) && this.$sn.validate.json(result.data);
        }
        if (verify) {
          let res = {};
          if (this.$sn.getConfig('isInRechargeVerifyCardSeparateSwagger')) {
            res = result;
            res.code = res.code.toString();
          }
          else {
            res = {
              code: JSON.parse(result.data).ResultCode,
              msg: JSON.parse(result.data).ResultMsg
            };
            const transfer = JSON.parse(result.data);
            delete transfer.ResultCode;
            delete transfer.ResultMsg;
            this.$set(res, 'data', transfer);
          }
          if (res.code === '0') {
            if (this.$sn.validate.object(this.inRechargeMerchantSerial)) {
              if (this.$sn.validate.empty(this.inRechargeMerchantSerial[res.data.hosArea])) {
                this.inRechargeMerchantSerial = this.inRechargeMerchantSerial.ordinary;
              }
              else {
                this.inRechargeMerchantSerial = this.inRechargeMerchantSerial[res.data.hosArea];
              }
            }
            this.getInCardBalance();
          }
          else {
            this.isShowInCardIrregularPrompt = true;
            this.$sn.assembly.modal({
              caption: res.msg,
              isCancel: false
            });
          }
        }
        else {
          this.isSystemFailed = true;
        }
      });
    },
    getInCardBalance() {
      const params = {
        url: Swagger.getCardBalance,
        method: 'POST',
        header: true,
        data: JSON.stringify({
          bindType: this.$sn.utils.getPlatformType(),
          cardNo: this.inCardSerial,
          clinicType: this.perpetual.IN_CARD_CLINIC_TYPE,
          hosArea: '',
          hosId: this.$sn.utils.getHospitalId(),
          idCardNo: '',
          openId: this.$sn.utils.getOpenId(),
          patName: '',
          patientId: this.selectedPatient.patientId,
          reservedDate: this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_ETYY ? this.selectedPatient.patientBirthday : '',
          state: ''
        })
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        this.inCardBalance = '--.--';
        this.inCardPrefixSum = '';
        this.isRestrictRechargeCost = false;
        this.isShowVerifyInCardBalancePrompt = false;
        this.maxInRecharge = this.$sn.getConfig('maxInRecharge');
        if (result) {
          if (result.code === 0) {
            if (result.data) {
              this.inCardBalance = result.data.cardBalance;
              this.inCardPrefixSum = result.data.prepay;
              this.selectedPatient.inCardBalance = result.data.cardBalance;
              if (!this.$sn.getConfig('isInRechargeVerifyCardPrefixBalance') && this.$sn.validate.object(this.inRechargeMerchantSerial)) {
                if (this.$sn.validate.empty(this.inRechargeMerchantSerial[result.data.hosArea])) {
                  this.inRechargeMerchantSerial = this.inRechargeMerchantSerial.ordinary;
                }
                else {
                  this.inRechargeMerchantSerial = this.inRechargeMerchantSerial[result.data.hosArea];
                }
              }
              if (!this.verifyRestrictRechargeCost()) {
                this.isRestrictRechargeCost = true;
              }
              if (this.$sn.getConfig('isRechargeVerifyInCardBalance')) {
                this.isShowVerifyInCardBalancePrompt = result.data.operateState === '0';
              }
            }
          }
          else {
            if (this.$sn.utils.getHospitalId() === this.perpetual.HOSPITAL_ID_WLZY && result.msg.indexOf('您不需要缴纳住院押金') !== -1) {
              this.$sn.assembly.modal({
                caption: Messages.RECHARGE017,
                isCancel: false,
                success: (modal) => {
                  if (modal.confirm) {
                    this.navigateUrl('/');
                  }
                }
              });
            }
            else {
              this.$sn.assembly.modal({
                caption: Messages.RECHARGE019,
                isCancel: false
              });
            }
          }
        }
        else {
          this.$sn.assembly.modal({
            caption: Messages.C001,
            isCancel: false
          });
        }
      });
    },
    getPromptInfo() {
      this.$sn.utils.ordinaryRequest({
        domain: 'static',
        url: '/hos/ui/caption/recharge/prompt.js?time=' + this.$sn.format.date(this.$sn.utils.getCurrentTime(), 'yyyyMMddHHmmss')
      }).then(result => {
        if (result && result.in && result.in.recharge && result.in.recharge[this.$sn.utils.getHospitalId()] && result.in.recharge[this.$sn.utils.getHospitalId()].length > 0) {
          this.promptInfo = result.in.recharge[this.$sn.utils.getHospitalId()];
        }
      });
    },
    verifyRestrictRechargeCost() {
      if (this.$sn.validate.empty(this.rechargeCost)) {
        return true;
      }
      if (this.maxInRecharge === 0) {
        return parseFloat(this.rechargeCost) >= this.$sn.getConfig('minInRecharge');
      }
      else {
        return this.$sn.getConfig('minInRecharge') <= parseFloat(this.rechargeCost) && parseFloat(this.rechargeCost) <= this.maxInRecharge;
      }
    },
    verifyRestrictRechargeCostInteger() {
      if (!this.$sn.getConfig('isRestrictInRechargeCostInteger')) {
        return true;
      }
      return this.$sn.validate.integer(this.rechargeCost);
    },
    verifyPermitRecharge() {
      if (!this.selectedPatient || !this.selectedPatient.patientId) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT001,
          success: (modal) => {
            if (modal.confirm) {
              this.navigateUrl('addition-patient');
            }
          }
        });
        return false;
      }
      if (!this.inCardSerial) {
        this.$sn.assembly.modal({
          caption: Messages.PATIENT043,
          success: (modal) => {
            if (modal.confirm) {
              this.navigateUrl('addition-card');
            }
          }
        });
        return false;
      }
      if (this.inCardBalance === '--.--') {
        this.$sn.assembly.modal({
          caption: '未查询到有效的在院住院信息，无法支付住院预交金。',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (!this.rechargeCost || parseFloat(this.rechargeCost) <= 0 || !this.$sn.validate.amount(this.rechargeCost)) {
        this.$sn.assembly.modal({
          caption: Messages.RECHARGE008,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (parseFloat(this.rechargeCost) < this.$sn.getConfig('minInRecharge')) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.RECHARGE007, [this.$sn.getConfig('minInRecharge')]),
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.maxInRecharge > 0 && parseFloat(this.rechargeCost) > this.maxInRecharge) {
        this.$sn.assembly.modal({
          caption: this.$sn.format.caption(Messages.RECHARGE006, [this.maxInRecharge]),
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (!this.isThroughRechargeTimeVerification) {
        this.$sn.assembly.modal({
          caption: '充值时间为每天' + this.$sn.getConfig('rechargeStartTime') + '-' + this.$sn.getConfig('rechargeEndTime') + '。',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isRestrictRechargeCost) {
        let caption = '单笔充值金额不能';
        if (this.$sn.getConfig('maxInRecharge') > 0) caption += '大于' + this.$sn.getConfig('maxInRecharge') + '元或者';
        caption += '小于' + this.$sn.getConfig('minInRecharge') + '元！';
        this.$sn.assembly.modal({
          caption: caption,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isShowVerifyInCardBalancePrompt) {
        const compare = {
          [this.perpetual.HOSPITAL_ID_NYXDYRM]: '未获取到就诊人的住院信息，不允许充值！',
          [this.perpetual.HOSPITAL_ID_JNRM]: '暂不支持出院患者和扶贫患者充值，请至窗口结算',
          [this.perpetual.HOSPITAL_ID_SZY]: '已出院无法充值'
        };
        this.$sn.assembly.modal({
          caption: compare[this.$sn.utils.getHospitalId()] || '您已出院，请至窗口结算！',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isSystemFailed) {
        this.$sn.assembly.modal({
          caption: Messages.C001,
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      if (this.isShowInCardIrregularPrompt) {
        this.$sn.assembly.modal({
          caption: '未查询到在院记录',
          durationConfirm: 3,
          disabledConfirm: false,
          autoConfirm: true,
          isCancel: false
        });
        return false;
      }
      return true;
    },
    formatRechargeCost(value) {
      value = value.toString();
      const standard = value.split('.');
      if ((standard[1] || '').length < 2) {
        standard[1] = standard[1] || '';
        standard[1] += new Array(2 - standard[1].length + 1).join('0');
      }
      return standard.join('.');
    },
    async goRecharge(reg) {
      const exhibition = (serial, qr) => {
        this.payResultParams = {
          func: this.perpetual.FUNCTION_ID_ZYCZ,
          title: '请您扫码进行充值',
          sub: '',
          label: '充值',
          cost: this.rechargeCost,
          pay: {
            [reg]: {
              serial: serial,
              qr: qr
            }
          },
          interaction: {
            text: '前往充值记录',
            disabled: true,
            func: () => {
              this.navigateUrl('/recharge/in/homepage/record', '', {
                type: this.perpetual.IN_CARD_CLINIC_TYPE
              });
            }
          }
        };
        this.exhibitionPayResult = true;
      };
      if (this.verifyPermitRecharge()) {
        this.verifyCurrentTime(new Date());
        if (this.isThroughRechargeTimeVerification) {
          this.rechargeCost = this.formatRechargeCost(this.rechargeCost);
          let primary = reg;
          const ExtendInfo = {};
          let ip = '';
          if (this.$sn.utils.getSubRegType(reg)) {
            this.$set(ExtendInfo, 'subPayType', this.$sn.utils.getSubRegType(reg));
            if (this.$sn.utils.isYuanQi()) {
              this.$set(ExtendInfo, 'patId', this.inCardSerial);
              this.$set(ExtendInfo, 'patName', this.selectedPatient.patientName);
              this.$set(ExtendInfo, 'inCardNo', this.inCardSerial);
              if (this.$sn.utils.getRegType() === this.perpetual.REG_TYPE_YUANQI2) {
                ip = await Tools.getIp();
              }
            }
            this.$set(ExtendInfo, 'busType', this.perpetual.PAY_BUSINESS_TYPE_IN_RECHARGE);
            primary = this.$sn.utils.getRegType();
            console.log(ip);
          }
          let Subject = '住院充值';
          if (!this.$sn.validate.empty(this.$sn.getConfig('inRechargeSubjectLabel'))) {
            const label = [];
            this.$sn.getConfig('inRechargeSubjectLabel')[1].split(',').forEach(el => {
              if (!this.$sn.validate.empty(this.$sn.format.getQuality(this, el))) {
                label.push(this.$sn.format.getQuality(this, el));
              }
            });
            if (label.length > 0) Subject = this.$sn.format.caption(this.$sn.getConfig('inRechargeSubjectLabel')[0], label);
          }
          if (this.$sn.getConfig('pcUpdateRecharge')) {
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest({
              url: Swagger.pcUpdateRechargeScanQR,
              method: 'POST',
              header: true,
              data: JSON.stringify({
                appId: this.$sn.utils.getHospitalId(),
                cardNo: this.inCardSerial,
                cardType: this.perpetual.IN_CARD_CLINIC_TYPE,
                dataType: this.$sn.utils.getPlatformType(),
                extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                extendType: '',
                himServiceId: '',
                himServiceType: '',
                limitPay: this.$sn.getConfig('isRestrictCreditCardInRecharge') ? '' : '0',
                openid: this.$sn.utils.getOpenId(),
                outTradeNo: '',
                pagePath: '',
                payAccountNo: this.inRechargeMerchantSerial,
                payType: primary,
                phoneNumber: this.selectedPatient.patientPhone,
                projectType: this.$sn.utils.getProjectType(),
                remark: '备注',
                serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
                subject: Subject,
                totalFee: this.rechargeCost,
                userId: this.selectedPatient.patientId,
                userName: this.selectedPatient.patientName
              })
            }).then(result => {
              this.$sn.assembly.loading(false);
              if (result) {
                if (result.code === 0) {
                  if (!this.$sn.validate.empty(result.data) && !this.$sn.validate.empty(result.data.outTradeNo) && !this.$sn.validate.empty(result.data.Data)) {
                    this.$sn.assembly.loading(true);
                    this.$sn.utils.ordinaryRequest({
                      url: Swagger.storePaymentParameter,
                      method: 'POST',
                      data: JSON.stringify({
                        accountId: this.$sn.utils.getAccountId(),
                        cardNo: this.inCardSerial,
                        cardType: this.perpetual.IN_CARD_CLINIC_TYPE,
                        dataType: this.$sn.utils.getPlatformType(),
                        deptId: '',
                        deptName: '',
                        doctorId: '',
                        doctorName: '',
                        extendInfo: this.$sn.validate.empty(ExtendInfo) ? '' : JSON.stringify(ExtendInfo),
                        extendType: '',
                        himServiceId: '',
                        himServiceType: '',
                        hosId: this.$sn.utils.getHospitalId(),
                        noticeType: this.perpetual.NOTICE_TYPE_IN_RECHARGE,
                        outTradeNo: result.data.outTradeNo,
                        patientId: this.selectedPatient.patientId,
                        patientIdCard: this.selectedPatient.patientIdCardNo,
                        patientName: this.selectedPatient.patientName,
                        patientPhone: this.selectedPatient.patientPhone,
                        payAccountNo: this.inRechargeMerchantSerial,
                        payType: primary,
                        platformId: this.$sn.utils.getPlatformType(),
                        platformUserId: this.$sn.utils.getOpenId(),
                        projectType: this.$sn.utils.getProjectType(),
                        remark: '',
                        totalFee: this.rechargeCost
                      }),
                      reload: false
                    }).then(res => {
                      this.$sn.assembly.loading(false);
                      if (res && res.code === 0 && res.data && res.data.ResultCode && (res.data.ResultCode === 0 || res.data.ResultCode === '0')) {
                        exhibition(result.data.outTradeNo, result.data.Data);
                      }
                      else {
                        this.$sn.assembly.modal({
                          caption: Messages.RECHARGE002,
                          isCancel: false
                        });
                      }
                    });
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: this.$sn.validate.empty(result.data.outTradeNo) || this.$sn.validate.empty(result.data.Data) ? Messages.RECHARGE003 : Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.msg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C001,
                  isCancel: false
                });
              }
            });
          }
          else {
            this.$sn.assembly.loading(true);
            this.$sn.utils.ordinaryRequest({
              url: Swagger.pcRechargeScanQR,
              method: 'POST',
              header: true,
              data: JSON.stringify({
                body: Subject,
                cardTypeCode: this.perpetual.IN_CARD_CLINIC_TYPE,
                expand: '',
                hosId: this.$sn.utils.getHospitalId(),
                ip: '',
                patientCard: this.inCardSerial,
                patientCardId: this.selectedPatient.patientIdCardNo,
                patientId: this.selectedPatient.patientId,
                patientName: this.selectedPatient.patientName,
                patientPhone: this.selectedPatient.patientPhone,
                payType: primary,
                platformId: 'PCNYXH000S',
                serviceType: this.perpetual.SERVICE_TYPE_RECHARGE,
                terminalId: 'PCNYXH000S',
                totalFee: this.rechargeCost
              }),
              reload: false
            }).then(result => {
              this.$sn.assembly.loading(false);
              if (result) {
                if (result.code === 0) {
                  if (result.data && this.$sn.validate.json(result.data)) {
                    const res = JSON.parse(result.data);
                    if (res.ResultCode === '0' && res.outTradeNo && res.Data) {
                      exhibition(res.outTradeNo, res.Data);
                    }
                    else {
                      this.$sn.assembly.modal({
                        caption: Messages.RECHARGE003,
                        isCancel: false
                      });
                    }
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.RECHARGE003,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.msg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C001,
                  isCancel: false
                });
              }
            });
          }
        }
      }
    },
    sendBackPatient(id) {
      if (id) {
        this.selectedPatient = this.patientList.find(item => item.patientId === id);
        this.$sn.utils.setHospitalLocalStorage('CurrentPatient', this.selectedPatient);
      }
    },
    sendBackOption(item) {
      this.rechargeCost = item;
    },
    sendBackPayResult(type) {
      this.getInCardBalance();
      this.homepage_mixin_sendBackPayResult(type);
    },
    sendBackCreatePatient(type) {
      if (type) {
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionCreatePatient = false;
    },
    sendBackBindCard(type, patient) {
      if (type) {
        this.selectedPatient = patient;
        this.patientList = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
      }
      this.exhibitionBindCard = false;
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'addition-patient') {
        this.exhibitionCreatePatient = true;
      }
      else if (url === 'addition-card') {
        this.exhibitionBindCard = true;
      }
      else this.homepage_mixin_navigateUrl(url, item, params, type);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/pages/recharge/recharge";
</style>
